import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import isBefore from 'date-fns/isBefore'
import addDays from 'date-fns/addDays'
import startOfDay from 'date-fns/startOfDay'
import CardName from '../../components/card/name/CardName'
import { Number, PrintList } from '../../components/card/PrintList'
import OnPageSpinner from '../../components/general/OnPageSpinner'
import H3 from '../../components/general/H3'
import translate from '../../helper/translate'
import { get } from '../../helper/api'
import { setValidationInfo } from '../../state/actions/deckbuilder'
import SetName from '../../components/card/name/SetName'
import Icon from '../../components/general/Icon'
import ToolbarFlyout from './components/ToolbarFlyout'
import ReleaseDate from '../../components/text/ReleaseDate'
import formats from '../../data/formats'
import { getSetLink } from '../../helper/set'

class FlyoutLegalStatus extends Component {
	static propTypes = {
		deck: PropTypes.object.isRequired,
		setValidationInfo: PropTypes.func.isRequired,
		t: PropTypes.func.isRequired
	}

	componentDidMount() {
		this.load()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.deck.slug !== this.props.deck.slug) {
			this.load()
		}
	}

	load = () => {
		const { deck, setValidationInfo } = this.props

		if (deck.slug) {
			get(`decks/${deck.slug}/validationInfo`, ({ invalidLegalSince, invalidLimitedList, legalSince, legalSinceSet, legalStatus, tooSmallMain, genesysPointsExceeded }) => {
				setValidationInfo(invalidLegalSince, invalidLimitedList, legalSince, legalSinceSet, legalStatus, tooSmallMain, genesysPointsExceeded)
			})
		}
	}

	render() {
		const { deck, t } = this.props

		const legal = deck.legalSince && isBefore(new Date(deck.legalSince), addDays(startOfDay(new Date()), 1))
		const legalFuture = deck.legalSince && !isBefore(new Date(deck.legalSince), addDays(startOfDay(new Date()), 1))

		if (deck.changes.cards || deck.changes.format || deck.changes.season) {
			return (
				<ToolbarFlyout info centered>
					<Icon name="information-circle" />
					{t('general.deckLegalPleaseSave')}
				</ToolbarFlyout>
			)
		}

		return !deck.saving && (deck.invalidLimitedList || deck.invalidLegalSince) ? (
			<ToolbarFlyout legal={!deck.tooSmallMain && !deck.genesysPointsExceeded && deck.invalidLimitedList.length === 0 && deck.invalidLegalSince.length === 0}>
				{!legal && legalFuture && !deck.legalStatus && deck.legalSinceSet && (
					<>
						<ParagraphAboveList>{t('general.deckLegalLegalSince')}</ParagraphAboveList>

						<PrintList>
							<Link to={getSetLink(deck.legalSinceSet)}>
								<SetName name={deck.legalSinceSet.name} setNumber={deck.legalSinceSet.setNumber} />
							</Link>
						</PrintList>
					</>
				)}

				{deck.tooSmallMain && (
					<>
						<H3>{t('general.deckLegalTooSmallMain')}</H3>
						<p>{t('general.invalidTooSmallMain', { min: formats[deck.format].deckMin })}</p>
					</>
				)}

				{deck.genesysPointsExceeded && (
					<>
						<H3>{t('general.deckLegalGenesysPointsExceeded')}</H3>
						<p>{t('general.invalidGenesysPointsExceeded')}</p>
					</>
				)}

				{deck.invalidLimitedList.length > 0 && (
					<>
						<H3>{t('general.invalidLimitedList')}</H3>
						<PrintList>
							{deck.invalidLimitedList.map(card => (
								<Link to={`/card/${card.slug}`} key={card.slug}>
									<CardName
										disableHover
										name={card.name}
										image={card.image}
									/>
								</Link>
							))}
						</PrintList>
					</>
				)}

				{deck.invalidLegalSince.length > 0 && (
					<>
						<H3>{deck.legalSince || deck.tooSmallMain || deck.invalidLimitedList.length > 0 ? t('general.invalidLegalSince') : t('general.invalidNonFormatCards')}</H3>
						{!deck.legalSince && !deck.tooSmallMain && deck.invalidLimitedList.length === 0 && deck.legalStatus !== 'ocg' && (
							<p>{t('general.invalidNonFormatCardsDescription')}</p>
						)}
						{!deck.tooSmallMain && deck.invalidLimitedList.length === 0 && deck.legalStatus === 'ocg' && (
							<p>{t('general.invalidOcgCardsDescription')}</p>
						)}
						<PrintList>
							{deck.invalidLegalSince.map(card => (
								<Link to={`/card/${card.slug}`} key={card.slug}>
									<CardName
										disableHover
										name={card.name}
										image={card.image}
									/>
									<Number>
										<ReleaseDate releaseInternational={card.legalSince} />
									</Number>
								</Link>
							))}
						</PrintList>
					</>
				)}

				{!deck.tooSmallMain && !deck.genesysPointsExceeded && deck.invalidLimitedList.length === 0 && deck.invalidLegalSince.length === 0 && (
					<p>
						{t('general.deckLegalDescription')}
					</p>
				)}
			</ToolbarFlyout>
		) : <OnPageSpinner />
	}
}

const ParagraphAboveList = styled.p`
	margin-bottom: 0.5rem;
`

const enhance = compose(
	connect(null, dispatch => bindActionCreators({
		setValidationInfo
	}, dispatch)),
	translate('general')
)

export default enhance(FlyoutLegalStatus)
